import React from 'react';
import classNames from 'classnames';

import css from './IconNoteBook.module.css';

/**
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own root class
 * @param {string?} props.rootClassName overwrite components own root class
 * @returns {JSX.Element}
 */
const IconNoteBook = props => {
  const { className, rootClassName, open } = props;
  const classes = classNames(rootClassName || css.root, className);

  return open ? (
    <svg
      className={classes}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M1.33398 10.7626V3.33203C1.33398 2.59992 1.92485 2.00518 2.65559 2.05009C3.3065 2.09009 4.07631 2.16917 4.66732 2.32513C5.36679 2.5097 6.19806 2.90284 6.85549 3.25047C7.06022 3.35873 7.27794 3.43382 7.50077 3.47614V13.5952C7.29877 13.5507 7.10169 13.4789 6.9156 13.3797C6.24927 13.0245 5.38829 12.6127 4.66732 12.4224C4.08285 12.2682 3.3235 12.1891 2.67722 12.1487C1.93801 12.1025 1.33398 11.5032 1.33398 10.7626ZM3.45537 5.51509C3.18747 5.44812 2.91601 5.611 2.84903 5.87889C2.78206 6.14679 2.94494 6.41826 3.21283 6.48523L5.8795 7.1519C6.1474 7.21887 6.41887 7.05599 6.48584 6.7881C6.55281 6.5202 6.38993 6.24873 6.12204 6.18176L3.45537 5.51509ZM3.45537 8.18176C3.18747 8.11478 2.91601 8.27766 2.84903 8.54556C2.78206 8.81346 2.94494 9.08493 3.21283 9.1519L5.8795 9.81857C6.1474 9.88554 6.41887 9.72266 6.48584 9.45476C6.55281 9.18687 6.38993 8.9154 6.12204 8.84842L3.45537 8.18176Z"
        fill="#A9D12E"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.50077 13.5952C8.70269 13.5507 8.89968 13.4788 9.08571 13.3797C9.75203 13.0245 10.613 12.6127 11.334 12.4224C11.9185 12.2682 12.6778 12.1891 13.3241 12.1487C14.0633 12.1025 14.6673 11.5032 14.6673 10.7626V3.28896C14.6673 2.57399 14.1032 1.9871 13.3886 2.01199C12.6362 2.0382 11.6986 2.11618 11.0007 2.32513C10.3956 2.50627 9.69086 2.86962 9.11654 3.202C8.92226 3.31444 8.71461 3.39703 8.50077 3.44941V13.5952ZM12.7887 6.48523C13.0566 6.41826 13.2195 6.14679 13.1525 5.87889C13.0855 5.611 12.8141 5.44812 12.5462 5.51509L9.8795 6.18176C9.6116 6.24873 9.44872 6.5202 9.5157 6.7881C9.58267 7.05599 9.85414 7.21887 10.122 7.1519L12.7887 6.48523ZM12.7887 9.1519C13.0566 9.08493 13.2195 8.81346 13.1525 8.54556C13.0855 8.27766 12.8141 8.11478 12.5462 8.18176L9.8795 8.84842C9.6116 8.9154 9.44872 9.18687 9.5157 9.45476C9.58267 9.72266 9.85414 9.88554 10.122 9.81857L12.7887 9.1519Z"
        fill="#A9D12E"
      />
    </svg>
  ) : (
    <svg
      className={classes}
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.8335 0.341777V13.6666L10.0002 13.6666C11.8858 13.6666 12.8286 13.6666 13.4144 13.0809C14.0002 12.4951 14.0002 11.5523 14.0002 9.66665V4.33331C14.0002 2.44769 14.0002 1.50489 13.4144 0.919099C12.8286 0.333313 11.8858 0.333313 10.0002 0.333313H6.00016L5.8335 0.341777ZM7.16683 3.33331C7.16683 3.05717 7.39069 2.83331 7.66683 2.83331H11.0002C11.2763 2.83331 11.5002 3.05717 11.5002 3.33331C11.5002 3.60946 11.2763 3.83331 11.0002 3.83331H7.66683C7.39069 3.83331 7.16683 3.60946 7.16683 3.33331ZM7.16683 5.66665C7.16683 5.3905 7.39069 5.16665 7.66683 5.16665H11.0002C11.2763 5.16665 11.5002 5.3905 11.5002 5.66665C11.5002 5.94279 11.2763 6.16665 11.0002 6.16665H7.66683C7.39069 6.16665 7.16683 5.94279 7.16683 5.66665ZM2.00063 3.83331C2.00519 2.27616 2.0544 1.45065 2.58595 0.919099C3.03594 0.46911 3.69661 0.364793 4.8335 0.340611V13.6593C3.69661 13.6352 3.03594 13.5308 2.58595 13.0809C2.0544 12.5493 2.00519 11.7238 2.00063 10.1666H2.66683C2.94297 10.1666 3.16683 9.94279 3.16683 9.66665C3.16683 9.3905 2.94297 9.16665 2.66683 9.16665H2.00016V7.49998H2.66683C2.94297 7.49998 3.16683 7.27612 3.16683 6.99998C3.16683 6.72384 2.94297 6.49998 2.66683 6.49998H2.00016V4.83331H2.66683C2.94297 4.83331 3.16683 4.60946 3.16683 4.33331C3.16683 4.05717 2.94297 3.83331 2.66683 3.83331H2.00063ZM2.00063 3.83331H1.3335C1.05735 3.83331 0.833496 4.05717 0.833496 4.33331C0.833496 4.60946 1.05735 4.83331 1.3335 4.83331H2.00016V4.33331C2.00016 4.15872 2.00016 3.99221 2.00063 3.83331ZM2.00016 7.49998H1.3335C1.05735 7.49998 0.833496 7.27612 0.833496 6.99998C0.833496 6.72384 1.05735 6.49998 1.3335 6.49998H2.00016V7.49998ZM2.00016 9.16665H1.3335C1.05735 9.16665 0.833496 9.3905 0.833496 9.66665C0.833496 9.94279 1.05735 10.1666 1.3335 10.1666H2.00063C2.00016 10.0078 2.00016 9.84124 2.00016 9.66665V9.16665Z"
        fill="#F59498"
      />
    </svg>
  );
};

export default IconNoteBook;
